<template>
  <div class="d-flex align-center">
    <v-btn class="mr-2" color="primary" outlined fab @click="rotateLeft">
      <img src="/invoices/rotate_left.png" width="24" height="24" />
    </v-btn>
    <v-btn color="primary" outlined fab @click="rotateRight">
      <img src="/invoices/rotate_right.png" width="24" height="24" />
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'PDFRotationButtons',
  props: {
    rotate: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      classesToExclude: [
        'v-overlay--active',
        'theme--dark'
      ]
    }
  },
  mounted() {
    this.activateComponent()
  },
  beforeDestroy() {
    this.deactivateComponent()
  },
  methods: {
    rotateLeft() {
      this.rotate(-90)
    },
    rotateRight() {
      this.rotate(90)
    },
    activateComponent() {
      document.body.classList.add('pdf-rotation-active')
      this.removeOverlayClasses()
    },
    deactivateComponent() {
      document.body.classList.remove('pdf-rotation-active')
    },
    removeOverlayClasses() {
      this.$nextTick(() => {
        const overlays = document.querySelectorAll('.v-overlay')
        overlays.forEach(overlay => {
          this.classesToExclude.forEach(className => {
            overlay.classList.remove(className)
          })
        })
      })
    }
  }
}
</script>

<style>
body.pdf-rotation-active .v-overlay {
  z-index: 0 !important;
  background: transparent !important;
}
</style>